<template>
  <!-- 微型简答题 -->
  <div class="SelectDate">
    <div v-if="!data.answered">
      <div class="question">
        <div class="title">
          <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
          <span class="span" v-if="data.rule?data.rule.subTitle:false">{{data.rule.subTitle}}</span>
        </div>
        <div class="text" v-for="o in data.questionDes?JSON.parse(data.questionDes):[]" :key="JSON.stringify(o)" v-text="o.txt">
        </div>
      </div>
      <!-- 答案部分 -->
      <div class="answer">
        <!-- <el-input v-model="input" :placeholder="data.rule?(data.rule.placeholder?data.rule.placeholder:'请输入内容'):'请输入内容'"></el-input> -->
        <el-date-picker
          v-model="input"
          type="date"
          placeholder="请选择日期">
        </el-date-picker>
      </div>
    </div>
    <div v-else>
      <div class="question">
        <div class="title">
          <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
          <span class="span" v-if="data.rule?data.rule.subTitle:false">{{data.rule.subTitle}}</span>
        </div>
        <div class="text" v-for="o in data.questionDes?JSON.parse(data.questionDes):[]" :key="JSON.stringify(o)" v-text="o.txt">
        </div>
      </div>
      <!-- 答案部分 -->
      <div class="answer">
        <!-- <el-input v-model="input" :disabled="disabledBol" :placeholder="data.rule?(data.rule.placeholder?data.rule.placeholder:'请输入内容'):'请输入内容'"></el-input> -->
        <el-date-picker
          v-model="input"
          type="date"
          :disabled="disabledBol"
          placeholder="请选择日期">
        </el-date-picker>
      </div>
    </div>
    <!-- 答案隐藏文字id -->
    <div class="answerObj none">{{answerObj}}</div>
    <div class="isNecessary none">{{data.rule ? (data.rule.isNecessary ? 1 : 0) : 0}}</div>
  </div>
</template>

<script>

export default {
  props: {
    data: Object,
    disabledBol: Boolean
  },
  name: 'SelectDate',
  computed: {
    answerObj () {
      let obj
      if (!this.input) {
        obj = {
          msg: '请选择日期'
        }
      } else {
        obj = {
          questionId: this.data.questionId,
          item: this.input.getTime()
        }
      }
      return obj
    }
  },
  data () {
    return {
      input: null,
      otherList: []
    }
  },
  methods: {
    // 初始化
    init () {
      if (this.data.answered) {
        this.input = new Date(+this.data.answered)
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.SelectDate{
  margin-top: 24px;
  .question{
    margin-bottom: 16px;
    font-size: 16px;
    .title{
      color: #303133;
      .span{
        color: #909399;
        font-size: 12px;
        word-break: break-word;
      }
    }
    .text{
      font-size: 12px;
      line-height: 20px;
      color: #606266;
      margin-top: 8px;
      word-break: break-word;
      white-space: pre-wrap;
    }
  }
  .other{
    margin-top: 32px;
    .other_title, .other_item{
      font-size: 14px;
      line-height: 20px;
      span{
        margin-left: 16px;
        color: #296BFF;
      }
    }
    .other_title{
      margin-bottom: 16px;
    }
    .other_border{
      border-top: 1px solid #EBEEF5;
      margin-top: 32px;
    }
    .other_item_no{
      color: #909399;
      font-size: 12px;
      line-height: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/public/select-date.vue